import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  Grid,
  Button,
  Icon,
  Icons,
  Tooltip,
} from '@nextiva/next-ui-components';
import { CREATE_ROLE } from 'constants/drawerTitles';
import { CREATE_ROLE_OBJ } from 'constants/roles';

const ActionHeader = ({
  actionName,
  label,
  buttonStyle,
  buttonColor,
  disabled,
  buttonDisabled,
  onClick,
  roleList,
  'data-testid': dataTestId,
}) => {
  const downloadRolesCSV = () => {
    const csvDownloadLink = document.createElement('a');
    const csvHeader = ['name', 'assignedProfilesCount'].join(',');
    const csvBody = roleList
      .map((role) => [role.name, role.assignedProfilesCount].join(','))
      .join('\n');
    const csvData = `${csvHeader}\n${csvBody}`;
    const file = new Blob([csvData], { type: 'text/plain' });
    csvDownloadLink.href = URL.createObjectURL(file);
    csvDownloadLink.download = `roles.csv`;
    csvDownloadLink.click();
  };

  return (
    <Grid
      container
      sx={{
        paddingRight: '4.2%',
        marginBottom: '10px',
        alignItems: 'center',
      }}
    >
      <Grid item xs={10}>
        <span className="Heading2" data-testid={dataTestId}>
          {label}
        </span>
      </Grid>
      <Grid item xs={1}>
        <Tooltip placement="bottom" title="Download CSV File">
          <Icon
            data-testid="PlatformAdminUI-Roles-DownloadIcon"
            icon={Icons.download}
            size={24}
            role="button"
            onClick={downloadRolesCSV}
          />
        </Tooltip>
      </Grid>
      <Grid item xs={1} align="right">
        <Button
          id="toggleDrawerButton"
          disabled={buttonDisabled || disabled}
          color={buttonColor}
          variant="contained"
          onClick={() => onClick(CREATE_ROLE_OBJ, CREATE_ROLE)}
          style={buttonStyle}
          data-testid="PlatformAdminUI-RolesAndPermissions-Roles-CreateRole"
        >
          {actionName}
        </Button>
      </Grid>
    </Grid>
  );
};

ActionHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
  actionName: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  buttonStyle: PropTypes.object,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  roleList: PropTypes.array,
};

ActionHeader.defaultProps = {
  actionName: '',
  label: '',
  buttonDisabled: false,
  disabled: false,
  buttonColor: 'primary',
  buttonStyle: {},
  roleList: [],
};

const mapStateToProps = (state) => {
  return {
    roleList: state.rolesPermissions.roleList,
  };
};

export default connect(mapStateToProps)(ActionHeader);
